//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 48px 40px;
    gap: 10px;
    width: 100%;
`;